/* TanStack Query client: no retries on 4xx, short retries on network errors, no refetch storms. */
import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';
import { isNotConfiguredCode } from './not-configured';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (count, err) => {
          if (err instanceof ApiError && err.status >= 400 && err.status < 500) return false;
          // A feature that needs setup stays that way until the owner sets it up; asking again does not help.
          if (err instanceof ApiError && isNotConfiguredCode(err.code)) return false;
          return count < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
